import { isValidValue, setFormFieldValue } from "./FormHelper";

export const getFullName = (object) => {
    let fullName = "";
    if (object) {
        fullName = object?.name + " " + object?.surname;
    }
    return fullName;
};


export const getIndividFullName = (object) => {
    let fullName = ""
    if (isValidValue(object?.name)) {
        fullName = object.name;
    }

    if (isValidValue(object?.surname)) {
        fullName = fullName + " " + object.surname
    }

    return fullName;
};


export const getIndividFullGeneralities = (object) => {
    let fullName = ""
    if (isValidValue(object?.firstName)) {
        fullName = object.firstName;
    }

    if (isValidValue(object?.lastName)) {
        fullName = fullName + " " + object.lastName
    }

    return fullName;
};


export const getPartyFullName = (object) => {
    let fullName = "";
    if (object) {
        fullName = object.initials + " - " + object.officialName;
    }
    return fullName;
};


export const getPropertyValue = (object, property) => {
    if (object.hasOwnProperty(property)) {
        return object.property;
    }
    return "";
};


export const checkVerifiedCandidates = (candidates) => {
    if (isValidValue(candidates) === false) {
        return false;
    }

    if (candidates?.length === 0) {
        return false
    }

    for (const candidate of candidates) {
        const isVerified = candidate.isVerified;
        if (isVerified === false) {
            return false;
        }
    }

    return true;
    
};


export const beforeUploadHandler = () => {
    return false;
};


export const getReceiver = (receiver) => {
    const employee = receiver?.employee;
    const department = receiver?.department;

    if (isValidValue(employee)) {
        return getIndividFullName(employee);
    }

    if (isValidValue(department)) {
        return setFormFieldValue(department?.name);
    }

    return null;
};


export const getSender = (sender) => {
    const individual = sender?.individual;
    const legalentity = sender?.legalentity;

    if (isValidValue(individual)) {
        return getIndividFullName(individual);
    }

    if (isValidValue(legalentity)) {
        return setFormFieldValue(legalentity?.name);
    }

    return null;
};


export const getExternalSender = (sender) => {
    const individual = sender?.individual;
    const legalentity = sender?.legalEntity;

    if (isValidValue(individual)) {
        return getIndividFullName(individual);
    }

    if (isValidValue(legalentity)) {
        return setFormFieldValue(legalentity?.name);
    }

    return null;
};


export const convertJSONToFormData = (requestData) => {
    const formData = new FormData();

    for (const key in requestData) {
        if (requestData.hasOwnProperty(key)) {
            if (requestData[key] !== null && requestData[key] !== undefined) {
                if (requestData[key] instanceof Object && !(requestData[key] instanceof File)) {
                    for (const nestedKey in requestData[key]) {
                        if (requestData[key].hasOwnProperty(nestedKey)) {
                            if (isValidValue(requestData[key][nestedKey])) {
                                formData.append(`${key}.${nestedKey}`, requestData[key][nestedKey]);
                            }
                        }
                    }
                } else {
                    if (isValidValue(requestData[key])) {
                        formData.append(key, requestData[key]);
                    }
                }
            }
        }
    }

    return formData;
};